import ElINput from 'element-ui/lib/input'

export default {
  extends: ElINput,
  computed: {
    inputDisabled() {
      return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled
    },
  },
}
